import React from 'react';
import { Stack, Text, Link, UnorderedList, ListItem } from '@chakra-ui/react';
import CollapsibleItems from '../../components/shared/CollapsibleItems';

const COLLAPSIBLE_ITEMS = [
  {
    title: 'Functional',
    content: (
      <Stack spacing="3">
        <Text>
          Functional cookies are necessary to enable portions of the Service and
          its features to work as intended. For example, we use cookies to help
          recognize and remember you when you are logged into the Service so we
          can maintain your settings and preferences, such as your logged-in
          state. These cookies do not track your browsing activity on non-HOVER
          websites.You may disable any of these functional cookies as described
          below; but if you do, various functions of the Service may be
          unavailable to you or may not work as intended.
        </Text>
        <Text>
          Functional cookies are necessary to enable portions of the Service and
          its features to work as intended. For example, we use cookies to help
          recognize and remember you when you are logged into the Service so we
          can maintain your settings and preferences, such as your logged-in
          state. These cookies do not track your browsing activity on non-HOVER
          websites.You may disable any of these functional cookies as described
          below; but if you do, various functions of the Service may be
          unavailable to you or may not work as intended.
        </Text>
      </Stack>
    ),
  },
  {
    title: 'Analytical',
    content: (
      <Stack spacing="3">
        <Text as="p">
          We use cookies and similar tracking technologies to help us understand
          how you use our website, our mobile applications, our desktop clients,
          our white label products, such as GAF e360 and Beacon 3D+. By
          providing us with information about how you interact with our Service,
          these tools help us learn how to make the HOVER experience even better
          and customize our communications with you. On our website, for
          example, these technologies can tell us things like how you arrived at
          the site, if you have visited the site before, how long you stay on
          the site, and which pages you visit. To learn more about how to manage
          your web tracking overall, visit{' '}
          <Link href="https://allaboutdnt.com/#adjust-settings">
            https://allaboutdnt.com/#adjust-settings
          </Link>
          . We use the following analytics technologies:
        </Text>
        <UnorderedList spacing="3">
          <ListItem ml="7">
            Google Analytics. To learn more about Google Analytics and your
            privacy, visit the “How Google uses data when you use our partners’
            sites or apps” page at www.google.com/policies/privacy/partners/. To
            opt out of being tracked by Google Analytics when using our website,
            visit{' '}
            <Link href="https://tools.google.com/dlpage/gaoptout">
              https://tools.google.com/dlpage/gaoptout
            </Link>
            .
          </ListItem>
          <ListItem ml="7">
            Branch.io. To learn more about Branch.io and your privacy, visit{' '}
            <Link href="https://branch.io/policies/#privacy">
              https://branch.io/policies/#privacy
            </Link>
            . To opt out of being tracked by Branch.io on your mobile device(s),
            visit{' '}
            <Link href="https://branch.io/policies/#opt-out">
              https://branch.io/policies/#opt-out
            </Link>
            .
          </ListItem>
          <ListItem ml="7">
            Google Tag Manager – Tracks user behavior on the Websites, which
            helps us better understand how users are using the Websites. Learn
            more at{' '}
            <Link href="https://support.google.com/tagmanager/answer/6102821">
              https://support.google.com/tagmanager/answer/6102821
            </Link>
            , and to opt out, visit{' '}
            <Link href="https://support.google.com/analytics/answer/7519794">
              https://support.google.com/analytics/answer/7519794
            </Link>
            .
          </ListItem>
          <ListItem ml="7">
            Mix Panel – Mix Panel tracks user behavior on our HOVER products,
            which helps us to improve the HOVER service. Learn more at{' '}
            <Link href="https://mixpanel.com/legal/privacy-policy/">
              https://mixpanel.com/legal/privacy-policy/
            </Link>
            . To opt-out, visit{' '}
            <Link href="https://mixpanel.com/optout">
              https://mixpanel.com/optout
            </Link>
            .
          </ListItem>
          <ListItem ml="7">
            Segment – To learn more about Segment and your privacy, visit{' '}
            <Link href="https://segment.com/legal/privacy/">
              https://segment.com/legal/privacy/
            </Link>
          </ListItem>
          <ListItem ml="7">
            Braze – Braze is a platform for life-cycle marketing campaigns
            through first party channels, such as email, SMS, mobile and web
            push notifications, and in-app/in-browser messaging. To learn more
            about Braze and your privacy, visit{' '}
            <Link href="https://www.braze.com/privacy">
              https://www.braze.com/privacy
            </Link>
          </ListItem>
        </UnorderedList>
      </Stack>
    ),
  },
  {
    title: 'Advertising',
    content: (
      <Stack spacing="3">
        <Text>
          We collect a unique ad tracking identifier (the Advertising Identifier
          or “IDFA” on Apple devices and the Google Advertising ID or “GAID” on
          Android devices) from your device. These identifiers are unique to
          your device, but you can reset them or limit their use through your
          device settings, as described below. These identifiers do not contain
          your name or email address. We use these ad tracking identifiers
          together with our analytics technologies in order to inform our
          targeted advertising initiatives.
        </Text>

        <Text>
          These third-party cookies are placed by third-party advertising
          platforms or networks to collect information about your visits to and
          actions on certain pages of our Websites so that they can deliver ads
          for relevant HOVER products and services to you later, such as when
          you are on certain third-party sites. These cookies also track ad
          performance.
        </Text>

        <Text>
          We do not sell, rent, or share personal data with third parties as
          defined under the California Consumer Privacy Act of 2018 (California
          Civil Code Sec. 1798.100 et seq.), and we do not sell, rent, or share
          personal data with third parties for their direct marketing purposes
          as defined under California Civil Code Sec. 1798.83. We do permit
          third parties to collect personal data as described in our Privacy
          Policy for the business purposes described here.
        </Text>

        <Text>
          If you wish to opt-out of cookies that collect information to serve
          you interest-based ads generally, you may opt-out by clicking{' '}
          <Link href="https://www.networkadvertising.org/managing/opt_out.asp">
            here
          </Link>
        </Text>
      </Stack>
    ),
  },
  {
    title: 'Social Media',
    content: (
      <Stack spacing="3">
        <Text>
          Our website uses social media features provided by companies and
          services such as Facebook, Twitter, LinkedIn and others to enable you
          to share information with these channels. The social features are
          identified on our website by our display of the companies’ logos.
          These cookies are owned and controlled by third parties, and therefore
          the third parties – and not HOVER – are responsible for their use. As
          such, we can’t guarantee that we have listed every cookie you might
          get from a third party since a third party could change these cookies
          at any time as their needs change.
        </Text>
        <UnorderedList spacing="3">
          <ListItem ml="7">
            Facebook:{' '}
            <Link href="https://www.facebook.com/about/privacy">
              https://www.facebook.com/about/privacy
            </Link>
          </ListItem>
          <ListItem ml="7">
            Twitter:{' '}
            <Link href="http://twitter.com/privacy">
              http://twitter.com/privacy
            </Link>
          </ListItem>
          <ListItem ml="7">
            LinkedIn:{' '}
            <Link href="http://www.linkedin.com/static?key=privacy_policy">
              http://www.linkedin.com/static?key=privacy_policy
            </Link>
          </ListItem>
        </UnorderedList>
      </Stack>
    ),
  },
];

const CookiesInformationItems = () => (
  <CollapsibleItems items={COLLAPSIBLE_ITEMS} />
);

export default CookiesInformationItems;
